import React, {Component} from 'react'
import RowBoxItem from "./RowBoxItem";


class RowBoxItemContainer extends Component {
    render() {
        const {items, isPrivate, onRefresh, box, showDelete, onSelected, arrSelected, onCheckAll} = this.props

        return (
            <tbody>
            {items.map((item, index) => {
                return (
                    <RowBoxItem 
                        onRefresh={onRefresh}
                        key={item._id}  index={index}
                        isPrivate={isPrivate}
                        box={box}
                        showDelete={showDelete}
                        item={item}
                        arrSelected={arrSelected}
                        onSelected={onSelected}
                        onCheckAll={onCheckAll}
                    />
                )
            })}
            </tbody>
        )
    }
}

export default RowBoxItemContainer
